import { render, staticRenderFns } from "./BetgameWelcome.vue?vue&type=template&id=3df10866"
import script from "./BetgameWelcome.vue?vue&type=script&lang=js"
export * from "./BetgameWelcome.vue?vue&type=script&lang=js"
import style0 from "./BetgameWelcome.vue?vue&type=style&index=0&id=3df10866&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports